import * as types from './modal-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    isComponentOuvrirEnvoiMail: false,
    isComponentEnregistrerOpportuniteActive: false,
    isComponentConfirmationMail: false,
    isComponentAjoutClientActive: false,
    isComponentDiaporama: false,
    facesSelectDiapo: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_IS_COMPONENT_OUVRIR_MAIL](state, isComponentOuvrirEnvoiMail) {
    state.isComponentOuvrirEnvoiMail = isComponentOuvrirEnvoiMail;
  },
  [types.SET_IS_COMPONENT_ENREGISTRER_OPPORTUNITE_ACTIVE](state,
    isComponentEnregistrerOpportuniteActive) {
    state.isComponentEnregistrerOpportuniteActive = isComponentEnregistrerOpportuniteActive;
  },
  [types.SET_IS_COMPONENT_CONFIRMATION_MAIL](state, isComponentConfirmationMail) {
    state.isComponentConfirmationMail = isComponentConfirmationMail;
  },
  [types.SET_IS_COMPONENT_AJOUT_CLIENT](state, isComponentAjoutClientActive) {
    state.isComponentAjoutClientActive = isComponentAjoutClientActive;
  },
  [types.SET_IS_COMPONENT_DIAPORAMA](state, isComponentDiaporama) {
    state.isComponentDiaporama = isComponentDiaporama;
  },
  [types.SET_FACES_SELECT_DIAPO](state, facesSelectDiapo) {
    state.facesSelectDiapo = facesSelectDiapo;
  },
};
const actions = {
};

const getters = {
  isComponentOuvrirEnvoiMail(state) {
    return state.isComponentOuvrirEnvoiMail;
  },
  isComponentEnregistrerOpportuniteActive(state) {
    return state.isComponentEnregistrerOpportuniteActive;
  },
  isComponentConfirmationMail(state) {
    return state.isComponentConfirmationMail;
  },
  isComponentAjoutClientActive(state) {
    return state.isComponentAjoutClientActive;
  },
  isComponentDiaporama(state) {
    return state.isComponentDiaporama;
  },
  facesSelectDiapo: (state) => {
    return state.facesSelectDiapo;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/modal.js